/*
  Sleeping Dove — homepage engagement tracking (added 2026-06-21).
  Sends two custom events to GA4 (G-CF6LVNW70D) by REUSING the existing Google tag
  (gtag is already on the page via the Google & YouTube channel — confirmed live).
  We only emit events with send_to: the GA4 id, so we never touch page_view and never
  create a second tag — no double-counting, no Measurement Protocol secret.

    shop_cta_click     — a CTA that scrolls to the product cards was clicked
                         (params: cta_location, cta_label)
    shop_section_view  — the #shop product-card block scrolled into view (once/page)

  Guards: no-op in the theme editor (Shopify.designMode) and on any page where the
  Google tag didn't load, so behavior matches the channel pixel (which also skips the editor).
*/
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  var GA4 = 'G-CF6LVNW70D';
  function send(name, params) {
    if (typeof window.gtag !== 'function') return;
    params = params || {};
    params.send_to = GA4;
    try { window.gtag('event', name, params); } catch (e) {}
  }

  // 1) Clicks on any CTA that targets the product cards (#shop): hero button,
  //    sticky bars (desktop + mobile), and every "Shop" link on the page.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href*="#shop"], .sd-btn-hero-primary, a.sd-sticky-mobile, .sd-sticky-cta a');
    if (!a) return;
    var loc = a.closest('.sd-menu-drawer-panel') ? 'drawer'
            : a.closest('.sd-sticky-mobile, .sd-sticky-cta') ? 'sticky'
            : a.closest('#hero, .sd-hero-section') ? 'hero'
            : (function () { var s = a.closest('section[id], [id^="shopify-section"] > section, .sd-final-section, .sd-shop-link'); return (s && s.id) ? s.id : 'other'; })();
    send('shop_cta_click', {
      cta_location: loc,
      cta_label: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60)
    });
    // Drawer shop pill: close the drawer so the same-page #shop anchor is visible.
    if (a.hasAttribute && a.hasAttribute('data-sd-drawer-shop')) {
      var d = document.getElementById('sd-menu-drawer-details');
      if (d) d.removeAttribute('open');
    }
  }, true);

  // 1b) First-order ($25) doorways — [data-sd-open-form] buttons (cards strip, PDP
  //     price line) open the Klaviyo signup form and log which surface was used.
  //     Form id Wwsruk = "Sign-up $25 Product Page Popup" (stable since 2025-11).
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-sd-open-form]');
    if (!b) return;
    send('signup_offer_click', { offer_location: b.getAttribute('data-sd-open-form') || 'unknown' });
    try {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'Wwsruk']);
    } catch (err) {}
  }, true);

  // 2) Product-card section (#shop) scrolled into view — once per page load.
  function observeShop() {
    var shop = document.getElementById('shop');
    if (!shop || !('IntersectionObserver' in window)) return;
    var fired = false;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting && !fired) {
          fired = true;
          send('shop_section_view', { section_id: 'shop' });
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.1 });
    io.observe(shop);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeShop);
  else observeShop();
})();
